export default "__VITE_ASSET__DWT9nIqV__"